/**
 * Mover um item de lugar numa lista, sem mexer na original.
 *
 * Existe como função à parte (e testada) porque é a mesma conta em toda lista
 * ordenável do cadastro — variações hoje, o que vier depois — e porque errar o
 * `splice` por um índice troca a ordem que o operador vê pela ordem que ele
 * não pediu, calado.
 *
 * Índice fora da lista devolve a MESMA referência: é o clique no "subir" da
 * primeira linha, que não deve fazer nada nem provocar re-render.
 */
export function move(list, from, to) {
  if (from === to || from < 0 || from >= list.length || to < 0 || to >= list.length) return list;

  const copia = [...list];
  const [item] = copia.splice(from, 1);
  copia.splice(to, 0, item);

  return copia;
}
